<template>
    <router-link 
        :to="toUrl" 
        class="flex-shrink-0 my-auto mx-auto" 
        :style="props.font_family != '' ? { 'font-family': props.font_family} : ''"
    >
        <div v-if="isDarkTheme()" class="font-black tracking-tighter text-secondary" :class="props.customClass">
            TEACHER<span class="text-carrot">MAESTRA</span>VICTORIA
        </div>

        <div v-else class="font-black tracking-tighter" :class="props.customClass">
            TEACHER<span class="text-carrot">MAESTRA</span>VICTORIA
        </div>
    </router-link>
</template>

<script setup>
    import { defineProps, onMounted, ref } from 'vue';
    
    const props = defineProps({
        theme: {
            type: String,
            default: 'dark',
        },
        to: {
            type: String,
            default: '/'
        },
        font_family: {
            type: String,
            default: 'hoolister'
        },
        customClass: {
            type: String,
            default: 'text-sm md:text-lg '
        }
    });

    const toUrl = ref('/');
    const theme = ref('dark');
    onMounted(() => {
        theme.value = props.theme;
        toUrl.value = props.to;
    });

    function isDarkTheme() {
        return theme.value == 'dark';
    }

</script>